export const Flag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <g clip-path="url(#clip0_3260_1293)">
      <path
        d="M6.00004 2.49996L5.83337 1.66663H2.08337V8.74996H2.91671V5.83329H5.25004L5.41671 6.66663H8.33337V2.49996H6.00004Z"
        fill="#747480"
      />
    </g>
    <defs>
      <clipPath id="clip0_3260_1293">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Arrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      d="M5.4167 7.91668L5.4167 3.26251L7.45003 5.29584C7.61253 5.45834 7.8792 5.45834 8.0417 5.29584C8.2042 5.13334 8.2042 4.87084 8.0417 4.70834L5.29587 1.96251C5.13337 1.80001 4.87087 1.80001 4.70837 1.96251L1.96253 4.70834C1.80003 4.87084 1.80003 5.13334 1.96253 5.29584C2.12503 5.45834 2.38753 5.45834 2.55003 5.29584L4.58337 3.26251L4.58337 7.91668C4.58337 8.14584 4.77087 8.33334 5.00003 8.33334C5.2292 8.33334 5.4167 8.14584 5.4167 7.91668Z"
      fill="#747480"
    />
  </svg>
);

export const ColorFlag = ({ width = 12, height = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}`}
    height={`${height}`}
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clip-path="url(#clip0_2728_10912)">
      <path
        opacity="0.3"
        d="M6.18 3H3.5V6H7.12L7.32 7H9V4H6.38L6.18 3Z"
        fill="#27ACAA"
      />
      <path
        d="M7.2 3L7 2H2.5V10.5H3.5V7H6.3L6.5 8H10V3H7.2ZM9 7H7.32L7.12 6H3.5V3H6.18L6.38 4H9V7Z"
        fill="#27ACAA"
      />
    </g>
    <defs>
      <clipPath id="clip0_2728_10912">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ColorCase = ({ width = 12, height = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}`}
    height={`${height}`}
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clip-path="url(#clip0_2728_11465)">
      <path opacity="0.3" d="M2 4H10V9.5H2V4Z" fill="#C981B2" />
      <path
        d="M10 3H8V2C8 1.445 7.555 1 7 1H5C4.445 1 4 1.445 4 2V3H2C1.445 3 1.005 3.445 1.005 4L1 9.5C1 10.055 1.445 10.5 2 10.5H10C10.555 10.5 11 10.055 11 9.5V4C11 3.445 10.555 3 10 3ZM5 2H7V3H5V2ZM10 9.5H2V4H10V9.5Z"
        fill="#B14891"
      />
    </g>
    <defs>
      <clipPath id="clip0_2728_11465">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);